import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import { AccountRetitlingSuccessLayout } from 'Views/Page/Content/Templates/AccountRetitlingSuccessStep/layout';

const metaOverrideSet = fr.metaOverride({ base: BaseWizardStepOverride });

const AccountRetitlingSuccess = ({ resource }) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={AccountRetitlingSuccessLayout}
      LayoutProps={{
        resource,
      }}
      primaryActionLabel={resource.attr('primaryActionLabel') || undefined}
    />
  );
};

AccountRetitlingSuccess.defaultProps = {
};

AccountRetitlingSuccess.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AccountRetitlingSuccess;
